import Vue from 'vue'
import axios from 'axios'

const state = {
  isRegisteredPhoneNumber: null,
  isVerifiedPhoneNumber: false,
  isVerifying: false,
  verifiedStatus: null
}

const actions = {
  GET_VERIFICATION_CODE: ({commit}, submitData) => {
    commit('SET_REGISTERED_PHONE_NUMBER', null)
    const url = 'phone-verification/' + submitData.user_id

    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_REGISTERED_PHONE_NUMBER', response.error)
      })
  },
  RESEND_OTP: ({commit}, submitData) => {
    const url = 'phone-verification/resend-otp'
    axios.post(url, submitData)
      .then(res => {
        const response = res.data
        console.log('resend otp response', response)
        if (!response.error) {
          console.log('success resend otp')
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const mutations = {
  SET_REGISTERED_PHONE_NUMBER: (state, status) => {
    state.isRegisteredPhoneNumber = status
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/phone.verification.js